<template>
  <spinner-container :loading="localLoading">
    <back-btn />

    <v-row justify="center">
      <v-col cols="12" md="6">
        <Form :clinic="clinic" @emitDaData="update" />
      </v-col>
    </v-row>
  </spinner-container>
</template>

<script>
import Form from "@/components/clinic/Form";
import { mapState } from "vuex";
import SpinnerContainer from "@/components/container/SpinnerContainer";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    Form,
    SpinnerContainer,
    BackBtn,
  },
  data: () => ({}),
  computed: {
    ...mapState("Clinic", ["clinic"]),
    ...mapState("Loading", ["localLoading"]),
  },
  methods: {
    update(payload) {
      this.$store.dispatch("Clinic/update", payload).then(() => {
        this.$router.push({ name: "clinic" });
      });
    },
  },
  created() {
    this.$store.dispatch("Loading/changeLocalLoading");
    this.$store.dispatch("Clinic/getEach", this.$route.params.id).then(() => {
      this.$store.dispatch("Loading/changeLocalLoading");
    });
  },
};
</script>
